import Icon from 'components/global/Icon';
import Skeleton from 'components/global/Skeleton';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

import * as S from './ResultColumn.styled';

const ResultColumn = ({ data, isSubmitting }) => {
	const { shipmentID, error, errorMsg } = data;

	return shipmentID ? (
		<Typography>{shipmentID}</Typography>
	) : isSubmitting ? (
		<Skeleton />
	) : error ? (
		<Tooltip
			placement="bottom"
			title={
				<div
					style={{
						display: 'flex',
						flexDirection: 'column'
					}}>
					<Typography color="var(--alwaysWhiteColor)" noWrap>
						{error}
					</Typography>
					<Typography color="var(--alwaysWhiteColor)" noWrap>
						{errorMsg}
					</Typography>
				</div>
			}>
			<S.ErrorContainer>
				<Icon icon={faExclamationCircle} color="var(--red)" size="large" />
				<Typography showTooltip={false} color="var(--red)" fontWeight="500">
					errorDetail
				</Typography>
			</S.ErrorContainer>
		</Tooltip>
	) : undefined;
};

export default ResultColumn;
